<template>
  <v-form>
    <v-container>
      <div style="height: 10px;"></div>
      <div style="font-size: 20px;">{{ storeName }}</div>
      <div style="height: 30px;"></div>

      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            店舗棚卸比較
          </v-card-title>

          <div style="height: 30px;"></div>

          <v-layout row wrap align-center>
            <v-flex xs12>
              <v-text-field
                v-model="search"
                append-icon="search"
                label="商品名検索"
                single-line
                hide-details
                clearable
              ></v-text-field>
            </v-flex>

            <div style="height: 35px;"></div>

            <v-data-table
              :headers="headers"
              :items="storeItems"
              hide-actions
              class="elevation-1"
              style="width: 100%;    margin: 15px 0 0;"
              :search="search"
              :customFilter="customFilter"
              :no-data-text="$t('noTableDataAvailable')"
            >
              <template v-slot:items="props">
                <tr>                  
                  <td class="text-xs-left px-2">{{ props.item.itemName }}</td>
                  <td class="text-xs-left px-2">{{ props.item.stocktakingDate }}</td>
                  <td class="text-xs-left px-2">{{ props.item.yesterdayStocktakingDate }}</td>
                  <td class="text-xs-left px-2">{{ props.item.lastStocktakingDate }}</td>
                  <td class="text-xs-left px-2">{{ props.item.yesterdayStockQuantity }}</td>
                  <td class="text-xs-left px-2">{{ props.item.lastStockQuantity }}</td>
                  <td class="text-xs-left px-2">{{ props.item.comp }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-layout>
        </v-container>
      </v-card>

      <div style="height: 35px;"></div>

      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-btn block color="#4C728A" dark :to="{ name: 'admin/store-compare-stocktaking' }">
            <v-icon dark left>arrow_back</v-icon>
            {{ $t('back-btn') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import ServerApiCallService from '@/services/ServerApiCallService.js'
import moment from 'moment-timezone'

export default {
  created() {
    console.log('created')
    
    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)
    
    this.storeName = this.$route.params.storeName
    this.storeCode = this.$route.params.storeCode
    this.stocktakingDate = moment(this.$route.params.stocktakingDate).format('YYYYMMDD')

    // 점포의 상품정보 가져오기
    this.getStoreCompareStocktaking()
  },
  methods: {
    customFilter(items, search) {
      if (!search) {
        return items
      } else {
        let filteringItems = items.filter(function(value) {
          if (value.itemName.includes(search)) {
            return true
          } else {
            return false
          }
        })
        return filteringItems
      }
    },
    getStoreCompareStocktaking() {
      let request = {
        storeCode: this.storeCode,
        stocktakingDate: this.stocktakingDate
      }
      ServerApiCallService.getStoreCompareStocktaking(request)
        .then(response => {
          console.log("response: ", response);
          if (response.data.errors.length > 0) {
            alert(response.data.errors[0].errorDescription)
          } else {
            this.storeItems = response.data.storeItems          
            this.storeItems.forEach((item) => {
              if (item.lastStockQuantity == item.yesterdayStockQuantity) {
                item.comp = 0
              } else {
                item.comp = item.lastStockQuantity - item.yesterdayStockQuantity
              }
            })
          }
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    }      
  },
  data() {
    return {
      storeCode: '',
      storeName: '',
      stocktakingDate: '',
      search: '',
      storeItems: [],
      headers: [
        {
          text: '商品名',
          align: 'left',
          value: 'itemName',
          width: '16%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },       
        {
          text: '棚卸日(基準)',
          align: 'left',
          value: 'stocktakingDate',
          width: '14%',
          sortable: false,
          fixed: false,
          class: 'px-2'
        },
        {
          text: '前日棚卸日',
          align: 'left',
          sortable: false,
          value: 'yesterdayStocktakingDate',
          width: '14%',
          fixed: true,
          class: 'px-2'
        },
        {
          text: '最終棚卸日',
          align: 'left',
          sortable: false,
          value: 'lastStocktakingDate',
          width: '14%',
          fixed: true,
          class: 'px-2'
        },
        {
          text: '前日数量',
          align: 'left',
          sortable: false,
          value: 'stocks',
          width: '14%',
          fixed: true,
          class: 'px-2'
        },
        {
          text: '最終数量',
          align: 'left',
          sortable: false,
          value: 'lastStocktakingQuantity',
          width: '14%',
          fixed: true,
          class: 'px-2'
        },
        {
          text: '差分',
          align: 'left',
          sortable: false,
          value: 'stocks',
          width: '14%',
          fixed: true,
          class: 'px-2'
        }
      ]
    }
  }
}
</script>

<style>
.confirmed-items {
  background-color: #adadad;
}
#dt tr:nth-child(even) {
  background-color: #f2f2f2;
}
.column-input-for-realtime-stock {
  width: 75px !important;
  height: 40px;
  text-align: right;
  border: 1px solid #c7c7c7;
  padding: 0 4px;
  font-size: 13px;
}
.deleted-class-name {
  background-color: #b3b3b3;
}
tr.changed-class-name,
.theme--light.v-table
  tbody
  tr.changed-class-name:hover:not(.v-datatable__expand-row) {
  background-color: #ffcccc;
}
.out-stock-class-name {
  background-color: #ed2939;
}
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
</style>
